import AppContainer from "../Structure/AppContainer";
import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import toast, { Toaster } from "react-hot-toast";
import AuthContext from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import useStateCallback from "../../util/customHooks/useStateCallback";
import { useFilter } from "../../Context/FilterContext";
import RegisterDeliveryModal from "./RegisterDeliveryModal";
import ajaxStationSales from "../../util/remote/ajaxStationSales";
const ViewStationRecentSales = () => {
  const { toggleFilter, filterVisible } = useFilter();
  const itemsPerPageOptions = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];
  var station_idd = Number(window.localStorage.getItem("FuelFy@station_id"));
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [salesList, setSalesList] = useState([]);
  const [meta, setMeta] = useState([]);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [days, setDays] = useState(30);
  // Fetch Sales
  const fetchSales = async () => {
    setLoading(true);
    const data = {
      station_id: station_idd, // assuming the user belongs to a station
      page,
      items_per_page: itemsPerPage,
      days,
    };
    const response = await ajaxStationSales.recent_sales(data);
    setSalesList([]);
    setMeta([]);
    if (response.status === "OK") {
      setSalesList(response.details.list || []);
      setMeta(response.details.meta?.list_of_pages || []);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchSales();
  }, [page, itemsPerPage, days]);
  const setNextPageNumber = () => page < meta.length && setPage(page + 1);
  const setPreviousPageNumber = () => page > 1 && setPage(page - 1);
  const setPageNumber = (e, item) => {
    e.preventDefault();
    setPage(item);
  };
  // Helpers for formatting numbers
  const formatNumber = (num) => {
    if (!num) return "0";
    return Number(num).toLocaleString();
  };
  const formatAmount = (num) => {
    if (!num) return "0.00";
    return Number(num).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };
  return (
    <AppContainer
      title="Fuel Recent Sales"
      previousPageTitle="Dashboard"
      actions={[
        {
          label: "filter",
          icon: "fa-solid fa-filter",
          className: "btn btn-warning btn-sm",
          onClick: () => toggleFilter(),
        },
      ]}
    >
      <div className="container-fluid">
        <Toaster />
        {/* Filter Section */}
        {filterVisible && (
          <div className="row">
            <div className="col-12">
              <div className="card shadow-sm border-0 rounded-3">
                <div className="card-body p-4">
                  <div className="bg-light p-3 rounded-3 border mb-3">
                    <div className="row g-3 align-items-end">
                      {/* Select Days */}
                      <div className="col-lg-3">
                        <label className="form-label fw-semibold">
                          Days Range
                        </label>
                        <Select
                          value={{ value: days, label: `${days} days` }}
                          options={[
                            { value: 1, label: "Last 1 day" },
                            { value: 3, label: "Last 3 days" },
                            { value: 7, label: "Last 7 days" },
                            { value: 30, label: "Last 30 days" },
                          ]}
                          onChange={(selected) => {
                            setPage(1);
                            setDays(selected.value);
                          }}
                        />
                      </div>
                      {/* Items per page */}
                      <div className="col-lg-3">
                        <label className="form-label fw-semibold">
                          Items per page
                        </label>
                        <Select
                          value={itemsPerPageOptions.find(
                            (opt) => opt.value === itemsPerPage
                          )}
                          onChange={(selected) => {
                            setPage(1);
                            setItemsPerPage(selected.value);
                          }}
                          options={itemsPerPageOptions}
                          isSearchable={false}
                        />
                      </div>
                      {/* Apply */}
                      <div className="col-lg-6 d-flex justify-content-end">
                        <button
                          className="btn btn-primary btn-sm m-2"
                          onClick={fetchSales}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* Loading / No Data */}
        {loading ? (
          <div className="text-center my-5 fs-5 text-muted">
            Loading Sales...
          </div>
        ) : salesList.length === 0 ? (
          <div className="text-center my-5 fs-5 text-muted">No Sales Found</div>
        ) : (
          <>
            {/* Table View */}
            <div className="row">
              <div className="col-12">
                <div className="card custom-card">
                  <div className="card-body">
                    <div>
                      <h6 className="card-title mb-1">Fuel Sales</h6>
                      <p className="text-muted card-sub-title">
                        List of recent sales
                      </p>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-bordered text-nowrap mb-0">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Fuel Type</th>
                            {/* <th>Station</th> */}
                            <th>Quantity (L)</th>
                            <th>Selling Price</th>
                            <th>Total Amount</th>
                            <th>Attendant</th>
                            <th>Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {salesList.map((item, index) => (
                            <tr key={item.id}>
                              <td>{(page - 1) * itemsPerPage + index + 1}</td>
                              <td>{item.fuel_category}</td>
                              {/* <td>{item.station_name}</td> */}
                              <td> {formatNumber(item.quantity)}</td>
                              <td>UGX {formatNumber(item.selling_price)}</td>
                              <td>UGX {formatNumber(item.Amount)}</td>
                              <td>
                                {item.first_name} {item.last_name}
                              </td>
                              <td>{item.date}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {/* Pagination */}
        <div className="card-footer">
          <nav className="d-flex justify-content-center">
            <ul className="pagination mb-0">
              <li className="page-item">
                <button className="page-link" onClick={setPreviousPageNumber}>
                  Prev
                </button>
              </li>
              {Array.isArray(meta) &&
                meta.map((item) =>
                  page === item ? (
                    <li className="page-item active" key={item}>
                      <span className="page-link">{item}</span>
                    </li>
                  ) : (
                    <li className="page-item" key={item}>
                      <a
                        className="page-link"
                        href="#"
                        onClick={(e) => setPageNumber(e, item)}
                      >
                        {item}
                      </a>
                    </li>
                  )
                )}
              <li className="page-item">
                <button className="page-link" onClick={setNextPageNumber}>
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </AppContainer>
  );
};
export default ViewStationRecentSales;
